import { inject, Injectable } from '@angular/core';
import { OnboardingService } from '@app-shared/services/onboarding/onboarding.service';
import { SimpleCommand } from '@app-shared/command/async-simple-command.interface';
import { captureException } from '@sentry/angular';
import { FlowNavigatorService } from '../services/flow-navigator.service';

@Injectable()
export class OnboardingNextScreenCommand implements SimpleCommand {
  private _flowNavigatorService = inject(FlowNavigatorService);
  private _onboardingService = inject(OnboardingService);

  async execute(): Promise<void> {
    this._onboardingService.lastPagePath = this._flowNavigatorService.currentPath;
    await this._flowNavigatorService.navigateNext();

    // Fire-and-forget: lastPagePath is only for resume bookkeeping.
    // User answers are already saved by mediators before this runs.
    this._onboardingService.save().catch((e) =>
      captureException(`Error saving lastPagePath: ${e}`),
    );
  }
}
